export enum EventStatus {
  Draft = "Draft",
  Published = "Published"
}